import { Component, Inject, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ArrivalCreate, ArrivalVM, StationVM, TerminalVM } from '../../../../../models/ArrivalDepartureModel';
import { ArrivalDepartureService } from '../../../../../services/arrivaldeparture.service';
import { Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import moment from 'moment';

@Component({
    selector: 'app-arrival-new',
    templateUrl: './arrival-new.component.html',
    styleUrls: ['./arrival-new.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ArrivalNewComponent implements OnInit, OnDestroy {
  arrivalVM: ArrivalVM;
  stationsVM: StationVM[] = [];
  terminalsVM: TerminalVM[] = [];
  arrivalCreate: ArrivalCreate;
  isLoading: boolean = false;
  activeRequests: number = 0;

  @Input() organizationId: string = 'A848CCD3-FD8D-4035-925E-571EBB4E93E8';

  createArrivalForm: UntypedFormGroup;

  isDisabled: boolean = false;
  stationId: string;
  terminalId: string;
  scheduledArrival: string;
  time: string;
  arrivalCode: string;

  componentDestroyed$: Subject<boolean> = new Subject();

  constructor(
    public snackBar: MatSnackBar,
    public router: Router,
    public arrivalDepartureService: ArrivalDepartureService,
    private fb: UntypedFormBuilder,
  ) {}

  ngOnInit(): void {
    this.initCreateArrival();
  }

  setLoading(isLoading: boolean){
    this.isLoading = isLoading;
  }

  incrementActiveRequests(){
    this.activeRequests++;
    if(this.activeRequests === 1){
      this.setLoading(true);
    }
  }

  decrementActiveRequests(){
    if(this.activeRequests > 0){
      this.activeRequests--;
    }
    if(this.activeRequests === 0){
      this.setLoading(false);
    }
  }

  initCreateArrival() {
    this.scheduledArrival = moment().format();
    this.time = "00:00";
    this.initCreateArrivalForm();
    this.getStations();
    this.terminalsVM = [];
  }

  initCreateArrivalForm() {
    this.createArrivalForm = this.fb.group({
      scheduledArrival: [this.scheduledArrival, Validators.required],
      time: [this.time, Validators.required],
      arrivalCode: [this.arrivalCode, Validators.required]
    });
  }

  getStations() {
    this.incrementActiveRequests();
    this.terminalsVM = [];
    this.arrivalDepartureService
      .getStations(this.organizationId)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(stationsVM => {
        this.stationsVM = stationsVM;
        this.decrementActiveRequests();
      });
  }

  getTerminals(stationId: string) {
    this.incrementActiveRequests();
    this.arrivalDepartureService
      .getTerminals(stationId)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(terminalsVM => {
        this.terminalsVM = terminalsVM;
        this.decrementActiveRequests();
      });
  }

  stationChange(event) {
    if (event.value !== null) {
      this.stationId = event.value
      this.getTerminals(this.stationId);
    }
  }

  terminalChange(event) {
    if (event.value !== null) {
      this.terminalId = event.value;
    }
  }

  saveArrival() {
    this.incrementActiveRequests();
    this.arrivalCreate = this.getSaveData();
    console.log(this.arrivalCreate);
    this.arrivalDepartureService
    .createArrival(this.arrivalCreate)
    .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(arrivalVM => {
        this.arrivalVM = arrivalVM;
        console.log(arrivalVM);
        this.clearForm();
        this.snackBar.open('Ankomsten är skapad', 'OK', {
          verticalPosition: 'top'
        });
        this.decrementActiveRequests();
      },
      error => {
        this.snackBar.open(`Felkod: ${error.status}`, 'Doh!', {
          verticalPosition: 'top'
        });
        this.decrementActiveRequests();
      });
  }

  getSaveData() : ArrivalCreate {

    let arrivalCreate: ArrivalCreate = {
      arrivalCode: '',
      scheduledArrival: '',
      stationId: '',
      terminalId: ''
    };

    arrivalCreate.stationId = this.stationId;
    arrivalCreate.terminalId = this.terminalId;
    arrivalCreate.arrivalCode = this.createArrivalForm.controls['arrivalCode'].value;
    arrivalCreate.scheduledArrival = moment(this.createArrivalForm.controls['scheduledArrival'].value).format('YYYY-MM-DD') + 'T' + this.createArrivalForm.controls['time'].value;

    return arrivalCreate;
  }

  clearForm() {
    this.createArrivalForm.reset();
    this.initCreateArrival();
  }

  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }
}
